class Constant {
  static DEFAULT_CURRENCY_CODE = 'USD';
  static DEFAULT_ALERT_DAYS = [1, 2, 3, 4, 5];
  static DEFAULT_ALERT_STARTING_AT = '09:00';
  static DEFAULT_ALERT_ENDING_AT = '18:00';
  static DEFAULT_ALERT_ENABLED = true;
  static DEFAULT_ALERT_INCREMENT_MINUTES = 30;
  static DEFAULT_ALERT_PAUSED_DATE = '';
  static ALERT_INTERVAL_HOURLY = 'hourly';
  static ALERT_INTERVAL_BI_HOURLY = 'biHourly';
  static ALERT_INTERVAL_TWICE_PER_DAY = 'twicePerDay';
  static ALERT_INTERVAL_END_OF_DAY = 'endOfDay';

  static DATE_FORMAT_LONG = 'YYYY-MM-DDTHH:mm:ssZ';
  static DATE_FORMAT_SHORT = 'YYYY-MM-DD';

  static TIMER_NOT_RUNNING = 'notRunning';
  static TIMER_RUNNING = 'running';
  static TIMER_PAUSED = 'paused';
}

export default Constant;



// WEBPACK FOOTER //
// ./src/common/Constant.js